import React, { useState, useRef, useEffect } from 'react';
import { useLanguage } from '../context/LanguageContext';
import '../styles/AlphabetSwitcher.css';

export default function LanguageSwitcher() {
  const { lang, setLang } = useLanguage();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const options = [
    {
      id: 'uz',
      code: 'UZ',
      shortLabel: 'Õzbekça',
      title: 'Õzbekça'
    },
    {
      id: 'ru',
      code: 'RU',
      shortLabel: 'Русский',
      title: 'Русский'
    },
    {
      id: 'en',
      code: 'ENG',
      shortLabel: 'English',
      title: 'English'
    }
  ];

  const currentOption = options.find((o) => o.id === lang) || options[0];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  const handleSelect = (id) => {
    setLang(id);
    setIsOpen(false);
  };

  return (
    <div className="alphabet-switcher-wrapper no-translit" ref={dropdownRef}>
      <button
        type="button"
        className={`alphabet-toggle-btn no-translit ${isOpen ? 'active' : ''}`}
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setIsOpen((prev) => !prev);
        }}
        title="Sayt tilini tanlash / Выбор языка / Select language"
        aria-expanded={isOpen}
      >
        <span className="alphabet-globe-icon">🌐</span>
        <span className="alphabet-current-name">{currentOption.shortLabel}</span>
        <span className="alphabet-arrow-icon">{isOpen ? '▲' : '▼'}</span>
      </button>

      {isOpen && (
        <div className="alphabet-dropdown-menu no-translit" onClick={(e) => e.stopPropagation()}>
          <div className="alphabet-menu-header">
            {lang === 'ru' ? 'Выберите язык:' : lang === 'en' ? 'Select language:' : 'Tilni tanlang:'}
          </div>
          {options.map((opt) => (
            <button
              key={opt.id}
              type="button"
              className={`alphabet-menu-item no-translit ${lang === opt.id ? 'selected' : ''}`}
              onClick={() => handleSelect(opt.id)}
            >
              <div className="alphabet-item-main">
                <span className="lang-code-pill">{opt.code}</span>
                <span className="alphabet-item-title">{opt.title}</span>
              </div>
              {lang === opt.id && <span className="alphabet-check-mark">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
